import FiltrosCheckbox from './FiltrosCheckbox';
import Select from 'react-select';
import { Accordion } from 'react-bootstrap';
import { Contrib_AreaDto, Contrib_DefensoriaDto, Contrib_ServidorDto, Defensor_DefensorDto } from '@/api.types';
import { EnumUtils } from '@/shared/constants/enumlist';
import { SolarService } from '../solar.service';
import { SubmitHandler, useForm } from 'react-hook-form';
import { TipoFiltroRelatorios } from '../enum/tipo-filtro-relatorios.enum';
import { TiposAtendimentosSolar } from '../enum/tipos-atendimentos-solar.enum';
import { atendimentos_titular_input } from '@/api.types.extra';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';

interface IOpcao { value: number; label: string; }

export default function Relatorios() {
  const solarService = new SolarService();

  const { register, handleSubmit, setValue } =
    useForm<atendimentos_titular_input>();
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  const [showModalFilters, setShowModalFilters] = useState(false);
  const [tipoModalFilter, setTipoModalFilter] =
    useState<TipoFiltroRelatorios>(1);

  const [loaded, setLoaded] = useState<boolean>(false);

  const tipos_atendimentos = EnumUtils.generateEnumObjects(
    TiposAtendimentosSolar,
  );
  tipos_atendimentos.unshift({ value: -1, name: '-' });

  const [areas, setAreas] = useState<IOpcao[]>([]);
  const [servidores, setServidores] = useState<IOpcao[]>([]);
  const [defensorias, setDefensorias] = useState<IOpcao[]>([]);
  const [defensores, setDefensores] = useState<IOpcao[]>([]);

  useEffect(() => {
    Promise.all([
      solarService.enumerateAreas(),
      solarService.enumerateDefensores(),
      solarService.enumerateDefensorias(),
      solarService.enumerateServidores(),
    ])
      .then((res) => {
        res[0].unshift({ id: 0, nome: '-' });
        res[1].unshift({ id: 0, servidor: { id: -1, nome: '-' } });
        res[2].unshift({ id: 0, nome: '-' });
        res[3].unshift({ id: 0, nome: '-' });

        setAreas(
          res[0].map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
        setDefensores(
          res[1].map((item) => {
            return { value: item.id, label: item.servidor.nome };
          }),
        );
        setDefensorias(
          res[2].map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
        setServidores(
          res[3].map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );

        setLoaded(true);
      })
      .catch((err) => {
        console.warn(err);
      });
  }, []);

  const onSubmit: SubmitHandler<atendimentos_titular_input> = async (
    data,
    e,
  ) => {
    e?.preventDefault();

    try {
      const blob = await solarService.relatorioAtendimentos(data);

      if (blob) {
        const url = window.URL.createObjectURL(blob);
        setFileUrl(url);

        return () => {
          window.URL.revokeObjectURL(url);
        };
      }
    } catch (error) {
      toast.error(error as string);
    }
  };

  const handleSetParametros = (params: string) => {
    console.warn(params)
    // setInicio(params.inicio as string)
    // setFim(params.fim as string)
    // setRef(params.ref as boolean)
    // setCivel(params.civel)
    // setCriminal(params.criminal)
    // setDefensorId(params.defensor)
    // setDefensoriaId(params.defensoria)
    // setNucleoId(params.nucleo)
  };

  function ObterBotaoDeFiltro(
    tipoFiltro: TipoFiltroRelatorios,
    titulo: string,
  ) {
    return (
      <button
        type="button"
        className="btn btn-sm w-100 btn-outline-success m-2"
        title={titulo}
        onClick={() => {
          setTipoModalFilter(tipoFiltro);
          setShowModalFilters(true);
        }}
      >
        {titulo}
      </button>
    );
  }

  return (
    <>
      <form
        onSubmit={(event) => {
          void handleSubmit(onSubmit)(event);
        }}
      >
        <div className="row">
          <div className="col-md-12 d-print-none">
            <h3 className="pt-4">Relatórios</h3>
          </div>
          <hr className="pb-3 d-print-none" />

          <div className="col-md-2 p-0">
            <Accordion defaultActiveKey="1">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Favoritos</Accordion.Header>
                <Accordion.Body>(nenhum)</Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>Menu</Accordion.Header>
                <Accordion.Body>
                  <div className="form-check ps-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault1"
                      checked
                      onChange={() => { }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      Atendimentos Solar
                    </label>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Filtros</Accordion.Header>
                <Accordion.Body>
                  <div className="mb-2">
                    <label>Data Inicial:</label>
                    <input
                      type="date"
                      className="form-control"
                      id="p_data_inicial"
                      required
                      {...register('p_data_inicial')}
                    />
                  </div>
                  <div className="mb-2">
                    <label>Data Final:</label>
                    <input
                      type="date"
                      className="form-control"
                      id="p_data_final"
                      required
                      {...register('p_data_final')}
                    />
                  </div>
                  {ObterBotaoDeFiltro(
                    TipoFiltroRelatorios.tipoAtendimento,
                    'Tipos de atendimento',
                  )}
                  {ObterBotaoDeFiltro(
                    TipoFiltroRelatorios.areaAtuacao,
                    'Áreas de Atuação',
                  )}
                  {ObterBotaoDeFiltro(
                    TipoFiltroRelatorios.servidores,
                    'Servidores',
                  )}
                  {ObterBotaoDeFiltro(
                    TipoFiltroRelatorios.defensorias,
                    'Defensorias',
                  )}
                  {ObterBotaoDeFiltro(
                    TipoFiltroRelatorios.defensores,
                    'Defensores',
                  )}
                  {ObterBotaoDeFiltro(
                    TipoFiltroRelatorios.comarcas,
                    'Comarcas',
                  )}
                  {ObterBotaoDeFiltro(
                    TipoFiltroRelatorios.diretorias,
                    'Diretorias',
                  )}
                  {ObterBotaoDeFiltro(
                    TipoFiltroRelatorios.qualificacoes,
                    'Qualificações',
                  )}
                  <button
                    type="submit"
                    className="btn btn-sm w-100 btn-success m-2"
                    title="Gerar o relatório"
                  >
                    Gerar
                  </button>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>

          {loaded && (
            <FiltrosCheckbox
              show={showModalFilters}
              handleHide={() => setShowModalFilters(false)}
              tipoFiltro={tipoModalFilter}
              // defensores={defensores!}
              // defensorias={defensorias!}
              // nucleos={nucleos!}
              handleSetParametros={handleSetParametros}
            />
          )}

          <div className="col-md-10">
            <div className="col-md-12">
              {fileUrl && (
                <iframe
                  src={fileUrl}
                  title="Visualizador de Arquivo"
                  width="100%"
                  height="770px"
                  style={{ border: 'none' }}
                ></iframe>
              )}
            </div>
          </div>

          <div className="col-md-3 row">
            <div className="pb-3">
              <label htmlFor="p_tipo_atendimento">Tipo de Atendimento:</label>
              <select
                id="p_tipo_atendimento"
                className="form-control"
                {...register('p_tipo_atendimento')}
              >
                {tipos_atendimentos.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
              <input
                type="se"
                className="form-control"
                id="p_tipo_atendimento"
                {...register('p_tipo_atendimento')}
              />
            </div>
            <div className="pb-3">
              <label htmlFor="p_area_id">Área</label>
              {loaded && (
                <Select
                  id="p_area_id"
                  options={areas}
                  isClearable={true}
                  onChange={(e) => {
                    const s = areas!.find((a) => a.value === e!.value);
                    const f: Contrib_AreaDto = {
                      id: s?.value,
                      nome: s?.label,
                    } as Contrib_AreaDto;
                    setValue('p_area_id', f.id);
                  }}
                />
              )}
            </div>
            <div className="pb-3">
              <label htmlFor="p_servidor_id">Servidor:</label>
              {loaded && (
                <Select
                  id="p_servidor_id"
                  options={servidores}
                  isClearable={true}
                  onChange={(e) => {
                    const s = servidores!.find((a) => a.value === e!.value);
                    const f: Contrib_ServidorDto = {
                      id: s?.value,
                      nome: s?.label,
                    } as Contrib_ServidorDto;
                    setValue('p_servidor_id', f.id);
                  }}
                />
              )}
            </div>
            <div className="pb-3">
              <label htmlFor="p_defensoria_id">Defensoria:</label>
              {loaded && (
                <Select
                  id="p_defensoria_id"
                  options={defensorias}
                  onChange={(e) => {
                    const s = defensorias!.find((a) => a.value === e!.value);
                    const f: Contrib_DefensoriaDto = {
                      id: s?.value,
                      nome: s?.label,
                    } as Contrib_DefensoriaDto;
                    setValue('p_defensoria_id', f.id);
                  }}
                />
              )}
            </div>
            <div className="pb-3">
              <label htmlFor="p_defensor_id">Defensor:</label>
              {loaded && (
                <Select
                  id="p_defensor_id"
                  options={defensores}
                  onChange={(e) => {
                    const s = defensores!.find((a) => a.value === e!.value);
                    const f: Defensor_DefensorDto = {
                      id: s?.value,
                      servidor: { nome: s?.label },
                    } as Defensor_DefensorDto;
                    setValue('p_defensor_id', f.id);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
